import React from "react";

// The PropertyMakers rooftops monogram (marketing SPA copy of the app's mark).
export function RooftopMark({ size = 32, navy = "#2C4A87", gold = "#B7975A", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path d="M32 14 L48 27 L48 34 L32 21 L16 34 L16 27 Z" fill={navy} />
      <path d="M20 30 L32 39 L44 30 L44 46 L20 46 Z" fill={navy} opacity="0.92" />
      <rect x="29" y="40" width="6" height="6" rx="1" fill="#fff" />
      <rect x="14" y="49" width="36" height="3" rx="1.5" fill={gold} />
    </svg>
  );
}
